module.exports = __webpack_public_path__ + "static/media/13-10.fc055736.mp3";